import Icon from 'components/Icon/Icon.react';
import TokensTable from 'components/PushTokens/TokensTable.react';
import FormModal from 'components/FormModal/FormModal.react';
import Modal from 'components/Modal/Modal.react';
import Field from 'components/Field/Field.react';
import TextInput from 'components/TextInput/TextInput.react';
import BoxFieldset from 'components/BoxFieldset/BoxFieldset.react';
import FileUpload from 'components/FileUpload/FileUpload.react';
import styles from 'dashboard/Settings/Settings.scss';
import Label from 'components/Label/Label.react';
import Notification from 'components/Notification/Notification.react';
import React from 'react';

export default class PushTokens extends React.Component {
  constructor() {
    super();

    this.state = {
      showDialog: false,
      note: null
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      note: {
        type: 'error',
        message: nextProps.error
      }
    });
  }

  isEnabled = () => {
    const { tokenFile, bundle, key_id, team_id } = this.state;
    let enabled = false;
    if (
      (tokenFile && tokenFile.name) &&
      (bundle && bundle.length > 0) &&
      (key_id && key_id.length > 2) &&
      (team_id && team_id.length) > 2
    ) {
      enabled = true;
    }

    return enabled;
  }

  onChangeFile = (tokenFile) => {
    this.setState({
      showDialog: true,
      tokenFile,
    });
  }

  onUpload = async () => {
    const { tokenFile, bundle, key_id, team_id } = this.state;
    return this.props.onUpload({ file: tokenFile, type: "push-apple-token", bundle, key_id, team_id });
  }

  renderExtraFields = () => {
    const { showDialog, tokenFile = {} } = this.state;


    const modal = (
      <FormModal
        title="Apple push token"
        subtitle="Please add your Key ID and Team ID"
        open={showDialog}
        type={Modal.Types.INFO}
        submitText="Save"
        inProgressText={'Saving\u2026'}
        enabled={this.isEnabled()}
        onSubmit={this.onUpload}
        onClose={() => this.setState({ showDialog: false, tokenFile: undefined, bundle: undefined, key_id: undefined, team_id: undefined })}
        clearFields={() => { this.setState({ tokenFile: undefined, bundle: undefined, key_id: undefined, team_id: undefined }); }}
        buttonsInCenter={false}>
        <div className={styles.fileP8}>
          <Icon name='p8-cert' width={26} height={26} fill="#47689f" />
          {tokenFile.name}
        </div>
        <Field
          labelWidth={60}
          label={<Label text="Apple App ID/Budle ID" />}
          input={
            <TextInput
              value={this.state.bundle || ""}
              onChange={bundle => this.setState({ bundle })}
              placeholder="Apple App ID/Budle ID" />
          } />

        <Field
          labelWidth={60}
          label={<Label text="Key ID" />}
          input={
            <TextInput
              value={this.state.key_id || ""}
              onChange={key_id => this.setState({ key_id })}
              placeholder="Key ID" />
          } />

        <Field
          labelWidth={60}
          label={<Label text="Team ID" />}
          input={
            <TextInput
              value={this.state.team_id || ""}
              onChange={team_id => this.setState({ team_id })}
              placeholder="Team ID" />
          } />
      </FormModal>
    );

    return modal;
  }

  render() {
    let renderTable = this.props.uploadPending || (this.props.certs && this.props.certs.length > 0);

    return (
      <BoxFieldset el='settings__push_apple_push_tokens'>
        <div className={styles.settingsBox}>
          {this.props.uploadPending ? null :
            <Field
              labelWidth={60}
              label={<Label text='Certificate file' description='Upload your .p8 certificate file to enable push for iOS.' />}
              input={
                <FileUpload disabled={this.props.uploadPending}
                  accept='.p8'
                  onChange={this.onChangeFile} />
              }
            />
          }
          {
            renderTable
              ?
              <Field
                labelWidth={60}
                label={<Label
                  text='Uploaded tokens'
                // description='Remember, you can only upload two certificates per bundle.'
                />}
                input={<TokensTable {...this.props} />} />
              : null
          }
        </div>
        {this.renderExtraFields()}
        <Notification note={this.state.note} close={true} />
      </BoxFieldset>
    );
  }
}
